import { connect } from "react-redux";
import { post } from "../../../../../actions/general";
import { editTask } from "../../../../../store/plan/actions";
import removeTaskProp from "../../../../../store/plan/actions/removeTaskProp";

import lazyComponent from "./lazy";

export default connect(null, { post, editTask, removeTaskProp })(lazyComponent);
